import {AuthType} from "../../types/AuthType";

export const AuthSetInitialState = () => {
    let auth: AuthType = {
        currentUser: null,
        accessToken: null,
        initialState: true
    }

    const authObject = localStorage.getItem('auth');

    if(authObject) {
        auth = JSON.parse(authObject);
        auth.initialState = true;
    }

    return auth;
}